import { FocusType } from '@calendar';

export const TEMP_STUB_EVENT_ID = 'stubUnavailableEvent';
export const FOCUS_TO_STUB_EVENT = { type: FocusType.EVENT, id: TEMP_STUB_EVENT_ID };
